<template>
	<div>
		<!-- heading row -->
		<v-row class="mx-2 my-1">
			<v-col cols="12" md="3">
				<h2 class="text-left">Task Tags</h2>
			</v-col>

			<v-spacer></v-spacer>

			<v-col cols="12" md="3">
				<v-btn
					color="primary"
					@click="showTagDialog = true"
					id="add-new-tag"
				>
					<!-- @click for dialog -->
					Add New Tag
				</v-btn>
			</v-col>
		</v-row>

		<v-row justify="center" class="my-1">
			<v-col cols="12" md="8" sm="8" align-self="center">
				<v-card>
					<v-data-table
						:items="tagList"
						:headers="tagHeaders"
						disable-pagination
						hide-default-footer
						class="my-2"
					>
						<template v-slot:item.name="{ item }">
							<router-link
								:to="{ name: 'AllTasks', params: { tagId: item.id } }"
							>
							<span>
								{{ item.name }}
							</span>
							</router-link>
						</template>

						<template v-slot:item.color="{ item }">
							<div class="d-flex justify-center align-center">
								<div
									:style="`background: ${item.color}; border-radius: 50%; width: 26px; height: 26px`"
								>
								</div>
							</div>
						</template>
						
						<template v-slot:item.actions="{ item }">
							<div v-if="false">{{ item }}</div>
								<div class="responsive-icons">
									<v-icon 
										size="26"
										class="mr-2 blue--text text--darken-4"
										@click="triggerEditTag(item)"
									>
										mdi-pencil
									</v-icon>

									<v-tooltip bottom :disabled="!item.is_used">
										<template v-slot:activator="{ on }">
											<div v-on="on" class="d-inline-block">
												<v-icon 
													size="26"
													class="mr-2 red--text text--darken-4"
													@click="triggerDeleteTag(item)"	
													:disabled="item.is_used"
												>
													mdi-delete
												</v-icon>
											</div>
										</template>	
									<span>This Tag cannot be deleted as it is already in use.</span>
								</v-tooltip>
							</div>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>

		<AddEditTags
			:visible="showTagDialog"
			@closeTagDialog="closeTagDialog"
			feature="tasks"
			:endpointURL="endpointUrl"
			:tagData="selectedTag"
			:is_editing="is_editing"
			@fetchFreshTags="fetchFreshTags"
		/>

		<DeleteConfirmationDialog
			title="Are you sure you want to delete this tag?"
			:visible="showDeleteConfirmation"
			@deleteObject="deleteTag"
		/>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.message }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>

	</div>
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
import Helper from "@utils/misc"
import moment from "moment"
import AddEditTags from "@components/task/AddEditTags.vue"
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog.vue'
import TourHelper from "@utils/tour_helper";


export default {
	name: 'ManageTaskTags',

	components: {
		AddEditTags,
		DeleteConfirmationDialog
	},

	props: [],

	data() {
		return {
			moment: moment,

			snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},

			tagHeaders: [
				{
					text: "Name",
					value: "name",
					align: "center",
					sortable: true,
				},
				{
					text: "Color",
					value: "color",
					align: "center",
					sortable: false,
				},
				{
					text: "Actions",
					sortable: false,
					value: 'actions',
					align: 'center'
				},
			],

			tagList: [
				// { name: 'important', color: '#e5d549'},
				// { name: 'urgent', color: '#f54748'},
				// { name: 'deadline', color: '#f98404'},
				// { name: 'plan', color: '#3d84b8'},
				// { name: 'work', color: '#4aa96c'},
			],

			showTagDialog: false,

			showDeleteConfirmation: false,
			is_editing: false,

			selectedTag: null,
		}
	},

	computed: {
		...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
		
		endpointUrl(){
			return endpoints.taskTags;
		},
	},

	methods: {
		...mapActions(["setLoading"]),

		handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Manage Tasks", description: "View and edit various tags for tasks under this section."});
        steps.push({id: '2', description: "Add new tags by giving it's title and colour.", el: '#add-new-tag'});
        TourHelper.startTour(this, "manage__tags", steps);
    },

		// handle api errors
		async handleApiErrors(err) {
			this.setLoading(false);
			console.log(err);
			if (err.response) {
				this.snackbar.message = "Unable to process request";
				this.snackbar.color = "error";
				this.snackbar.visible = true;
			}
		},

		triggerEditTag(item) {
			this.is_editing = true
			this.selectedTag = Helper.clone(item)
			this.showTagDialog = true
		},

		triggerDeleteTag(item) {
			this.selectedTag = Helper.clone(item)
			this.showDeleteConfirmation = true
		},

		async deleteTag(confirm) {
			if(confirm) {
				// api call to delete tag
				var url = endpoints.taskTags + `${this.selectedTag.id}/`
				var response = await api.call(this.apiEssentials, url, api.Methods.DELETE)

				if(response) {
					this.snackbar.message = "Tag deleted successfully!";
					this.snackbar.color = "success";
					this.snackbar.visible = true;

					this.showDeleteConfirmation = false

					this.fetchAllTags()
				}
			}
			else{
				this.showDeleteConfirmation = false
			}
		},

		closeTagDialog(status) {
			this.showTagDialog = status
			this.is_editing = false
			this.selectedTag = null
		},

		async fetchAllTags() {
			var url = endpoints.taskTags
			var response = await api.call(this.apiEssentials, url)

			if(response) {
				this.tagList = response
			}
		},

		// emit from dialog to notify to fetch tags again
		fetchFreshTags(status) {
			if(status) {
				this.fetchAllTags()
			}
		}
	},

	created() {
		this.fetchAllTags()
		this.handleTour()
	}
}
</script>

<style>
.responsive-icons {
    /* To keep the icons from breaking */
  min-width: 60px;
}
</style>